module.exports = require("./el-GR.js");